import { createAsyncThunk } from "@reduxjs/toolkit";
import { apiCall } from "services/api";

import { CalendarFilters } from "./types";

export const getUserCalendar = createAsyncThunk(
  "/calendar/full",
  async (filters: CalendarFilters, { rejectWithValue }) => {
    try {
      const response = await apiCall().get("/my/calendar-full", {
        params: filters,
      });

      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getGoogleCalendarStatus = createAsyncThunk(
  "/google/calendar/status",
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiCall({ Accept: "application/json" }).get(
        "/google/calendar/status"
      );

      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getGoogleCalendarAuthUrl = createAsyncThunk(
  "/google/calendar/auth-url",
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiCall({ Accept: "application/json" }).get(
        "/google/calendar/auth-url"
      );

      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getGoogleCalendarSyncMeeting = createAsyncThunk(
  "/google/calendar/sync-meetings",
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiCall({ Accept: "application/json" }).post(
        "/google/calendar/sync-meetings",
        {}
      );

      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getCalendarDates = createAsyncThunk(
  "/calendar/dates",
  async (filters: CalendarFilters, { rejectWithValue }) => {
    try {
      const response = await apiCall().get("/my/calendar", {
        params: filters,
      });

      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response.data);
    }
  }
);
